import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CommandBar, css, TooltipHost, TooltipOverflowMode, mergeStyleSets } from '@fluentui/react';
import { useSelector } from 'react-redux';
import { __Consolidation, enum__Consolidation } from '../../../../../../common/Dictionaries';
import { calulateSystenDecimal, formatNumber, isNullOrEmpty, isNullUndefined, isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';
import SidePanelConfig from '../../ConsolidatedGroups/SidePanelConfig';
import DialogSelectElement from './DialogSelectElement';

function ItemGroup(props) {
  	const { t } = useTranslation();

    //Parametros de entrada.
    const { 
        inputParam_Object = null,
        inputParam_ElementId = null,
        inputParam_HasPageElementId = false,
        inputParam_ShowToolbar = true,
        inputParam_SetterSelectedElementToPanel = null,
        inputParam_ConsolidatedGroupDataSeries = null,
        inputParam_SetConsolidatedGroupDataSeries = null,
        inputParam_LastPeriod = null,
    } = props;
    
    const [isConfigPanelOpen, setIsConfigPanelOpen] = useState(false);
    
    const [isSelectElementToDialogOpen, setIsSelectElementToDialogOpen] = useState(false);
    const toolBarItems  = [
        {
            key: 'config',
            text: t('data-lang-lbl-configuration'),
            iconProps: { iconName: 'Settings' },
            onClick: () => onSetIsConfigurationPanelOpen(!isConfigPanelOpen)
        },
    ];

    const classNames = mergeStyleSets({
        overflow: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
    });

    const onSetIsConfigurationPanelOpen = (isOpen) => {
        if (!inputParam_HasPageElementId) {
            setIsSelectElementToDialogOpen(isOpen)
        }
        else {
            setIsConfigPanelOpen(isOpen)
        }
    }

    const setterSelectedElementToPanel = (item) => {
        if (item !== null) {
            inputParam_SetterSelectedElementToPanel && inputParam_SetterSelectedElementToPanel(item)
            setIsConfigPanelOpen(true)
        }
    }

    const validRelativePaths = (currentPatch) => {
        const paths = ['/Landing', '/Portfolio']

        return paths.filter(x => currentPatch.indexOf(x) === -1 ? false : true).length === 0;
    }

    const getColor = (object) =>{
        if (inputParam_LastPeriod === true) {
            return object.l_vals.length > 0 && !isNullUndefined(object.l_vals.reduce((a, b) => a.periodId > b.periodId ? a : b).scopeValue) ? object.l_vals.reduce((a, b) => a.periodId > b.periodId ? a : b).color : 'na'
        }
        else {
            return object.color
        }
    }

    const hideCommandButtons = validRelativePaths(window.location.href)

    const generateDom = () => {
        return inputParam_Object &&
            <>
                <div className='border ps-1 w-100 d-flex'>
                    <div className='px-0 d-flex' style={{width: "100%"}}>
                        {
                            !isNullOrEmpty(inputParam_Object.perspectiveCode) &&
                            <div className='p-0 my-auto mx-auto' >
                                <div className='pe-1 mx-auto' style={{width: "40px"}}>
                                    <div className='border my-1 px-2 text-center' style={{backgroundColor: inputParam_Object.perspectiveCode === enum__Consolidation.R ? "#104284" : "#2c8eff", color: "white", fontWeight: "bold"}}>
                                        {t(__Consolidation.find(x => x.key === inputParam_Object.perspectiveCode).letter)}
                                    </div>
                                </div>
                            </div>
                        }

                        <div className='px-0 me-auto my-auto w-100' style={{fontSize: "11px"}}>
                            <div className='my-1 ps-0 pe-1 text-start'>
                                <TooltipHost
                                    overflowMode={TooltipOverflowMode.Self}
                                    hostClassName={css(classNames.overflow)}
                                    content={ `${inputParam_Object.name} ${!isNullUndefinedOrEmpty(inputParam_LastPeriod) ? `(${inputParam_LastPeriod})` : ""}` }
                                    onTooltipToggle={false}
                                    styles={{
                                        root: { display: 'block', height: "33px", position: "relative" },
                                    }}
                                >
                                    <div style={{fontSize: "15px", position: "absolute", top: "50%", transform: "translateY(-50%)", height: (inputParam_Object.name.length <= 44 ? "auto" : "33px")}}>
                                        {inputParam_Object.name}
                                        { (!isNullUndefinedOrEmpty(inputParam_LastPeriod) && inputParam_LastPeriod === true && !isNullUndefined(inputParam_Object.l_vals) && inputParam_Object.l_vals.length > 0) && <><br/><div style={{fontSize: "11px"}}>{`(${Math.max(...inputParam_Object.l_vals.map(o => o.periodId))})`}</div></> }
                                    </div>
                                </TooltipHost> 
                            </div>
                        </div>
                    </div>
                    <div className='d-flex'>
                        <div className='px-0 my-auto' style={{width: "100%"}}>
                            <div style={{width: "120px"}}>
                                <TooltipHost
                                    content={
                                        inputParam_Object.scopeValue !== undefined && inputParam_Object.scopeValue !== null ?
                                            (inputParam_LastPeriod === true && !isNullUndefined(inputParam_Object.l_vals) && inputParam_Object.l_vals.length > 0 ? `${ !isNullUndefined(inputParam_Object.l_vals.reduce((a, b) => a.periodId > b.periodId ? a : b).scopeValue) ? formatNumber(inputParam_Object.l_vals.reduce((a, b) => a.periodId > b.periodId ? a : b).scopeValue) : t('no-data') }${!isNullUndefined(inputParam_Object.l_vals.reduce((a, b) => a.periodId > b.periodId ? a : b).scopeValue) ? '%' : ''}` : `${formatNumber(inputParam_Object.scopeValue)}%`) : t('no-data')
                                        }
                                >
                                    <div value-id={inputParam_Object.id} className={`cursor-pointer border my-1 px-2 text-center ${ " variable-value-color-" + getColor(inputParam_Object) } `}>
                                        {
                                            inputParam_LastPeriod === true &&
                                            <>
                                                {`${!isNullUndefined(inputParam_Object.l_vals) && inputParam_Object.l_vals.length > 0 ? `${ !isNullUndefined(inputParam_Object.l_vals.reduce((a, b) => a.periodId > b.periodId ? a : b).scopeValue) ? formatNumber(inputParam_Object.l_vals.reduce((a, b) => a.periodId > b.periodId ? a : b).scopeValue) : t('no-data') }${!isNullUndefined(inputParam_Object.l_vals.reduce((a, b) => a.periodId > b.periodId ? a : b).scopeValue) ? '%' : ''}` : t('no-data')}`}
                                            </>
                                        }
                                        {
                                            inputParam_LastPeriod === false &&
                                            <>
                                                {`${!isNullUndefined(inputParam_Object.scopeValue) ? `${formatNumber(inputParam_Object.scopeValue)}%` : t('no-data')}`}
                                            </>
                                        }
                                    </div>
                                </TooltipHost> 
                            </div>
                        </div>
                        <div className='pe-1 mx-auto'>
                        {
                            hideCommandButtons && inputParam_ShowToolbar && <CommandBar overflowItems={toolBarItems} styles={{root:{padding: "0", height: "40px"}}} />
                        }
                        </div>
                    </div>
                    {
                        isConfigPanelOpen &&
                        <SidePanelConfig
                            inputParam_IsPanelOpen={isConfigPanelOpen}
                            inputParam_ConsolidatedGroupDataSeries={inputParam_ConsolidatedGroupDataSeries}
                            inputParam_SetConsolidatedGroupDataSeries={inputParam_SetConsolidatedGroupDataSeries}
                            inputParam_EditMode={true}
                            inputParam_Object={inputParam_Object}
                            inputParam_ElementId={inputParam_ElementId}
                            inputParam_SetterIsPanelOpen={setIsConfigPanelOpen}
                        />
                    }
                    {
                        isSelectElementToDialogOpen &&
                        <DialogSelectElement
                            inputParam_EditMode={true}
                            inputParam_IsDialogOpen={isSelectElementToDialogOpen}
                            inputParam_SetterIsDialogOpen={setIsSelectElementToDialogOpen}
                            inputParam_ScopeId={inputParam_Object.id}
                            inputParam_SetterSelectedElementToPanel={setterSelectedElementToPanel}
                        />
                    }
                </div>
            </>
    }

    return (
        <>
            { generateDom() }
        </>
    );
}

ItemGroup.propTypes = {
    inputParam_Object: PropTypes.object.isRequired,
};

export default ItemGroup;